import { AdminCommunityMemberDTO } from '../dtos/AdminCommunityMember.dto';
import { CommunityMemberMultiRequestDTO } from '../infra/types';
import { AdminCommunityMemberModel } from '../models/CommunityMember.model';

export class AdminCommunityMemberUtil {
  public static maptToViewModel(
    dto: AdminCommunityMemberDTO,
  ): AdminCommunityMemberModel {
    return {
      id: dto.memberId,
      userId: dto.userId,
      communityId: dto.communityId,
      community: dto.community.name,
      isMultiMember: dto.userDetails.isMultiEnabled
        ? dto.userDetails.isMultiEnabled
        : false,
      email: dto.userDetails.email,
      firstName: dto.userDetails.firstName,
      fullName: dto.userDetails.fullName,
      lastName: dto.userDetails.lastName,
      isDeleted: dto.userDetails.isDeleted ? dto.userDetails.isDeleted : false,
      isEmailVerified: dto.userDetails.isEmailVerified
        ? dto.userDetails.isEmailVerified
        : false,
      scope: dto.scope,
      username: dto.userDetails.username,
      lastLogin: dto.userDetails.lastLogin ? dto.userDetails.lastLogin : null,
      status: dto.status,
    };
  }

  public static toRequestDTO(
    model?: AdminCommunityMemberModel,
  ): CommunityMemberMultiRequestDTO {
    return {
      userId: model ? model.userId : '',
      multiState: model ? model.isMultiMember : false,
    };
  }
}
